var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-61cc141e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("iframe", {
    style: { "display": "none" },
    onload: "resizeTextarea('company_profile',7)"
}, null, -1));
const _hoisted_2 = { class: "footerFixed" };
const _hoisted_3 = {
    id: "all_wrapper",
    class: "profile my_profile"
};
const _hoisted_4 = { class: "wrapper_1" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "プロフィール", -1));
const _hoisted_6 = { class: "inner" };
const _hoisted_7 = { class: "prof_1" };
const _hoisted_8 = { class: "ph edit" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "inner" };
const _hoisted_11 = { class: "name_box" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須", -1));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開", -1));
const _hoisted_14 = { class: "name" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    class: "bt_change modal_win",
    "data-target": "display-name-modal"
}, "変更", -1));
const _hoisted_16 = { class: "advice" };
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
    key: 2,
    class: "err"
};
const _hoisted_19 = { class: "prof_2" };
const _hoisted_20 = /*#__PURE__*/ _createStaticVNode("<dt class=\"must\" data-v-61cc141e> 業種 <br class=\"pc\" data-v-61cc141e><span class=\"must\" data-v-61cc141e>必須</span><span class=\"public\" data-v-61cc141e>公開</span><a class=\"bt_change modal_win sp\" data-target=\"industry-modal\" data-v-61cc141e>変更</a></dt>", 1);
const _hoisted_21 = { class: "f_box" };
const _hoisted_22 = { class: "f_l" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "f_r" }, [
    /*#__PURE__*/ _createElementVNode("a", {
        class: "bt_change modal_win pc",
        "data-target": "industry-modal"
    }, "変更")
], -1));
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", { class: "pc" }, null, -1));
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "optionally" }, "任意", -1));
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開", -1));
const _hoisted_27 = { class: "f_box" };
const _hoisted_28 = { class: "f_l" };
const _hoisted_29 = { class: "bread" };
const _hoisted_30 = /*#__PURE__*/ _createStaticVNode("<dt class=\"must\" data-v-61cc141e> 会社概要 <br class=\"pc\" data-v-61cc141e><span class=\"optionally\" data-v-61cc141e>任意</span><span class=\"public\" data-v-61cc141e>公開</span><a class=\"bt_change modal_win sp\" data-target=\"company-profile-modal\" data-v-61cc141e>変更</a></dt>", 1);
const _hoisted_31 = { class: "f_box" };
const _hoisted_32 = { class: "f_l" };
const _hoisted_33 = { style: { "white-space": "pre-line" } };
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "f_r" }, [
    /*#__PURE__*/ _createElementVNode("a", {
        class: "bt_change modal_win pc",
        "data-target": "company-profile-modal"
    }, "変更")
], -1));
const _hoisted_35 = /*#__PURE__*/ _createStaticVNode("<dt class=\"must\" data-v-61cc141e> 年商 <br class=\"pc\" data-v-61cc141e><span class=\"optionally\" data-v-61cc141e>任意</span><span class=\"public\" data-v-61cc141e>公開</span><a class=\"bt_change modal_win sp\" data-target=\"annual-sale-modal\" data-v-61cc141e>変更</a></dt>", 1);
const _hoisted_36 = { class: "f_box" };
const _hoisted_37 = { class: "f_l" };
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "f_r" }, [
    /*#__PURE__*/ _createElementVNode("a", {
        class: "bt_change modal_win pc",
        "data-target": "annual-sale-modal"
    }, "変更")
], -1));
const _hoisted_39 = /*#__PURE__*/ _createStaticVNode("<dt class=\"must\" data-v-61cc141e> 社員数 <br class=\"pc\" data-v-61cc141e><span class=\"optionally\" data-v-61cc141e>任意</span><span class=\"public\" data-v-61cc141e>公開</span><a class=\"bt_change modal_win sp\" data-target=\"employee-modal\" data-v-61cc141e>変更</a></dt>", 1);
const _hoisted_40 = { class: "f_box" };
const _hoisted_41 = { class: "f_l" };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "f_r" }, [
    /*#__PURE__*/ _createElementVNode("a", {
        class: "bt_change modal_win pc",
        "data-target": "employee-modal"
    }, "変更")
], -1));
const _hoisted_43 = { class: "min_link" };
const _hoisted_44 = ["onClick"];
import { ref, reactive, computed, onBeforeMount, onMounted, nextTick } from 'vue';
import { isArray } from '@vue/shared';
import { Link } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';
import axios from 'axios';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import ImageFrame from '@component/ImageFrame.vue';
import DisplayNameModal from '@component/Modals/EditProfile/DisplayNameModal.vue';
import IndustryModal from '@component/Modals/EditProfile/IndustryModal.vue';
import JobModal from '@component/Modals/EditProfile/JobModal.vue';
import CompanyProfileModal from '@component/Modals/EditProfile/CompanyProfileModal.vue';
import AnnualSaleModal from '@component/Modals/EditProfile/AnnualSaleModal.vue';
import EmployeeModal from '@component/Modals/EditProfile/EmployeeModal.vue';
import { ProfileUpdateType, QuestionType } from '@util/Consts';
import { tryJsonForObject } from '@util/Common';
export default /*#__PURE__*/ _defineComponent({
    __name: 'my_profile',
    props: {
        common: null,
        errors: null,
        user: null,
        is_examable: { type: Boolean }
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        const props = __props;
        const form = reactive({
            id: props.user.id,
            photo: props.user.photo,
            photo_file: null,
            name: props.user.name,
            industry_id: (_c = (_b = (_a = props.user) === null || _a === void 0 ? void 0 : _a.industry) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null,
            job_group_id: (_f = (_e = (_d = props.user) === null || _d === void 0 ? void 0 : _d.job_group) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : null,
            job_id: (_j = (_h = (_g = props.user) === null || _g === void 0 ? void 0 : _g.job) === null || _h === void 0 ? void 0 : _h.id) !== null && _j !== void 0 ? _j : null,
            other_job_name: (_k = props.user.other_job_name) !== null && _k !== void 0 ? _k : null,
            company_profile: (_l = props.user.company_profile) !== null && _l !== void 0 ? _l : '',
            annual_sale_id: (_p = (_o = (_m = props.user) === null || _m === void 0 ? void 0 : _m.annual_sale) === null || _o === void 0 ? void 0 : _o.id) !== null && _p !== void 0 ? _p : null,
            employee_id: (_s = (_r = (_q = props.user) === null || _q === void 0 ? void 0 : _q.employee) === null || _r === void 0 ? void 0 : _r.id) !== null && _s !== void 0 ? _s : null,
        });
        const industryOptions = ref([]);
        const jobOptions = ref([]);
        const annualSaleOptions = ref([]);
        const employeeOptions = ref([]);
        const inputIconRef = ref();
        const errors = reactive({
            name: '',
            photo: '',
            industry: '',
        });
        // 更新処理中か判定
        const processing = ref(false);
        // モーダル
        const displayNameModal = ref();
        const industryModal = ref();
        const jobModal = ref();
        const companyProfileModal = ref();
        const annualSaleModal = ref();
        const employeeModal = ref();
        const selectedIndustry = computed(() => {
            return getOptionName(form.industry_id, industryOptions.value);
        });
        const selectedJob = computed(() => {
            var _a, _b, _c, _d;
            if ((form.job_group_id === null || form.job_group_id === '') && form.other_job_name) {
                return ['その他', form.other_job_name];
            }
            const jobGroup = (_b = (_a = jobOptions.value) === null || _a === void 0 ? void 0 : _a.find((value) => value.id === form.job_group_id)) !== null && _b !== void 0 ? _b : null;
            const job = (_d = (_c = jobGroup === null || jobGroup === void 0 ? void 0 : jobGroup.jobs) === null || _c === void 0 ? void 0 : _c.find((value) => value.id === form.job_id)) !== null && _d !== void 0 ? _d : null;
            const result = [];
            if (jobGroup === null || jobGroup === void 0 ? void 0 : jobGroup.name) {
                result.push(jobGroup.name);
            }
            if (job === null || job === void 0 ? void 0 : job.name) {
                result.push(job.name);
            }
            if (form.other_job_name) {
                result.push(form.other_job_name);
            }
            return result;
        });
        const selectedAnnualSale = computed(() => {
            return getOptionName(form.annual_sale_id, annualSaleOptions.value);
        });
        const selectedEmployee = computed(() => {
            return getOptionName(form.employee_id, employeeOptions.value);
        });
        const getOptionName = (id, options) => {
            var _a, _b;
            if (isArray(options)) {
                const option = (_a = options === null || options === void 0 ? void 0 : options.find((value) => value.id === id)) !== null && _a !== void 0 ? _a : null;
                return (_b = option === null || option === void 0 ? void 0 : option.name) !== null && _b !== void 0 ? _b : '';
            }
            return '';
        };
        // 表示名入力イベント
        const onInputDisplayName = (value) => {
            const param = {
                update_type: ProfileUpdateType.NAME,
                name: value,
            };
            onSave(param, () => {
                form.name = value;
                displayNameModal.value.onCloseModal();
            });
        };
        // 業種選択イベント
        const onSelectedIndustry = (id) => {
            const param = {
                update_type: ProfileUpdateType.INDUSTRY,
                industry_id: id,
            };
            onSave(param, () => {
                form.industry_id = id;
                industryModal.value.onCloseModal();
            });
        };
        // 職種選択イベント
        const onSelectedJob = (job) => {
            if (!job.job_id && !job.other_job_name) {
                job.job_group_id = null;
            }
            const param = {
                update_type: ProfileUpdateType.JOB,
                job_id: job.job_id,
                other_job_name: job.other_job_name,
            };
            onSave(param, () => {
                form.job_group_id = job.job_group_id;
                form.job_id = job.job_id;
                form.other_job_name = job.other_job_name;
                jobModal.value.onCloseModal();
            });
        };
        // 会社概要入力イベント
        const onInputCompanyProfile = (value) => {
            const param = {
                update_type: ProfileUpdateType.COMPANY_PROFILE,
                company_profile: value,
            };
            onSave(param, () => {
                form.company_profile = value;
                companyProfileModal.value.onCloseModal();
            });
        };
        // 年商選択イベント
        const onSelectedAnnualSale = (id) => {
            const param = {
                update_type: ProfileUpdateType.ANNUAL_SALE,
                annual_sale_id: id,
            };
            onSave(param, () => {
                form.annual_sale_id = id;
                annualSaleModal.value.onCloseModal();
            });
        };
        // 社員数選択イベント
        const onSelectedEmployee = (id) => {
            const param = {
                update_type: ProfileUpdateType.EMPLOYEE,
                employee_id: id,
            };
            onSave(param, () => {
                form.employee_id = id;
                employeeModal.value.onCloseModal();
            });
        };
        const USER_HOME_SEARCH_SESSION_KEY = 'user-home-search';
        // ユーザホームへ遷移
        const onClickUserHome = () => {
            var _a;
            let searchForm = JSON.parse(sessionStorage.getItem(USER_HOME_SEARCH_SESSION_KEY));
            if (searchForm) {
                searchForm.question_type_id = "";
                searchForm.industry_id = "";
                searchForm.job_group_id = "";
                searchForm.job_group_name = "";
                searchForm.job_id = "";
                searchForm.other_job_name = "";
                searchForm.option_type = "4";
                searchForm.keyword = `user:${(_a = props.user) === null || _a === void 0 ? void 0 : _a.id}`;
                sessionStorage.setItem(USER_HOME_SEARCH_SESSION_KEY, JSON.stringify(searchForm));
            }
            Inertia.get(route('question.index'), { option_type: QuestionType.MY_POSTS, keyword: `user:${form.id}` });
        };
        // アイコン選択ダイアログ表示
        const openIconDialog = () => {
            inputIconRef.value.click();
        };
        // アイコン選択イベント
        const onChangeIcon = (event) => {
            const file = event.target.files[0];
            event.target.value = null;
            const url = URL.createObjectURL(file);
            const param = new FormData();
            param.append("photo_file", file);
            param.append("update_type", ProfileUpdateType.PHOTO);
            onSave(param, () => {
                form.photo_file = file;
                form.photo = url;
                isDeleteShow.shot = form.photo_file ? true : false;
            });
        };
        const onSave = (param, onSuccess) => {
            if (processing.value)
                return;
            processing.value = true;
            let contentType = 'application/json';
            if (param.update_type === ProfileUpdateType.PHOTO) {
                contentType = 'multipart/form-data';
            }
            axios.post(route('profile.update'), param, {
                headers: {
                    'content-type': contentType,
                }
            }).then(response => {
                var _a;
                const res = tryJsonForObject(response);
                if ((res === null || res === void 0 ? void 0 : res.status) === 422) {
                    const errors = JSON.parse(response.request.response);
                    setErrors(param.update_type, (_a = errors === null || errors === void 0 ? void 0 : errors.message) !== null && _a !== void 0 ? _a : '');
                    if (errors.errors.photo_file) {
                        alert(errors.message);
                        location.reload();
                    }
                    ;
                }
                else if ((res === null || res === void 0 ? void 0 : res.status) === 200) {
                    onSuccess();
                    setErrors(param.update_type, '');
                }
            }).finally(() => { processing.value = false; });
        };
        const setErrors = (type, message) => {
            switch (type) {
                case ProfileUpdateType.NAME:
                    errors.name = message;
                    break;
                case ProfileUpdateType.PHOTO:
                    errors.photo = message;
                    break;
                case ProfileUpdateType.INDUSTRY:
                    errors.industry = message;
                    break;
            }
        };
        const isDeleteShow = reactive({ shot: props.user.photo.includes('user/icon') });
        const deleteImage = () => {
            const isDelete = confirm('削除してもよろしいでしょうか?');
            if (!isDelete)
                return;
            Inertia.delete(route('profile.delete', { id: form.id }));
            isDeleteShow.shot = false;
            form.photo = 'images/user/default.svg';
        };
        const onClickMentor = () => {
            var _a, _b, _c, _d;
            const token = (_b = (_a = props.common['auth.user']) === null || _a === void 0 ? void 0 : _a.email_verified_token) !== null && _b !== void 0 ? _b : '';
            const email = (_d = (_c = props.common['auth.user']) === null || _c === void 0 ? void 0 : _c.email) !== null && _d !== void 0 ? _d : '';
            Inertia.get(route('mentor.register.basic', { token: token, email: email }));
        };
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            const [industries, jobs, annualSales, employees] = yield Promise.all([
                axios.get('industries').then(res => res.data).catch(e => []),
                axios.get('jobs').then(res => res.data).catch(e => []),
                axios.get('annual-sales').then(res => res.data).catch(e => []),
                axios.get('employees').then(res => res.data).catch(e => []),
            ]);
            industryOptions.value = industries;
            jobOptions.value = jobs;
            annualSaleOptions.value = annualSales;
            employeeOptions.value = employees;
        }));
        const openJobModal = () => {
            var _a;
            (_a = jobModal === null || jobModal === void 0 ? void 0 : jobModal.value) === null || _a === void 0 ? void 0 : _a.openModal(form);
        };
        onMounted(() => {
            nextTick(() => {
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common,
                    photo: form.photo
                }, null, 8, ["common", "photo"]),
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("input", {
                                            ref_key: "inputIconRef",
                                            ref: inputIconRef,
                                            type: "file",
                                            accept: ".jpeg,.jpg,.gif,.png",
                                            onChange: onChangeIcon,
                                            style: { "display": "none" }
                                        }, null, 544),
                                        _createElementVNode("a", {
                                            class: "bt_change",
                                            onClick: _withModifiers(openIconDialog, ["prevent"])
                                        }, null, 8, _hoisted_9),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createVNode(ImageFrame, {
                                                src: form === null || form === void 0 ? void 0 : form.photo
                                            }, null, 8, ["src"])
                                        ])
                                    ]),
                                    (isDeleteShow.shot)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "bt_delete del-sp",
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (deleteImage()), ["prevent"]))
                                        }, "画像削除"))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createTextVNode(" 表示名"),
                                        _hoisted_12,
                                        _hoisted_13,
                                        _createElementVNode("div", _hoisted_14, [
                                            _createTextVNode(_toDisplayString(form.name), 1),
                                            _hoisted_15
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("a", {
                                            onClick: _withModifiers(onClickUserHome, ["prevent"])
                                        }, [
                                            _createTextVNode("相談"),
                                            _createElementVNode("p", null, [
                                                _createElementVNode("span", null, _toDisplayString(props.user.question_count), 1),
                                                _createTextVNode("件 ")
                                            ])
                                        ], 8, _hoisted_17)
                                    ]),
                                    (isDeleteShow.shot)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            class: "bt_delete del-pc",
                                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (deleteImage()), ["prevent"]))
                                        }, "画像削除"))
                                        : _createCommentVNode("", true),
                                    (errors === null || errors === void 0 ? void 0 : errors.photo)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(errors.photo), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("dl", null, [
                                        _hoisted_20,
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_21, [
                                                _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(selectedIndustry)), 1),
                                                _hoisted_23
                                            ])
                                        ]),
                                        _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 職種 "),
                                            _hoisted_24,
                                            _hoisted_25,
                                            _hoisted_26,
                                            _createElementVNode("a", {
                                                class: "bt_change modal_win sp",
                                                "data-target": "job-modal",
                                                onClick: openJobModal
                                            }, "変更")
                                        ]),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_27, [
                                                _createElementVNode("div", _hoisted_28, [
                                                    _createElementVNode("ul", _hoisted_29, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedJob), (name) => {
                                                            return (_openBlock(), _createElementBlock("li", null, _toDisplayString(name), 1));
                                                        }), 256))
                                                    ])
                                                ]),
                                                _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "job-modal",
                                                        onClick: openJobModal
                                                    }, "変更")
                                                ])
                                            ])
                                        ]),
                                        _hoisted_30,
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_31, [
                                                _createElementVNode("div", _hoisted_32, [
                                                    _createElementVNode("p", _hoisted_33, _toDisplayString(form.company_profile), 1)
                                                ]),
                                                _hoisted_34
                                            ])
                                        ]),
                                        _hoisted_35,
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_36, [
                                                _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(selectedAnnualSale)), 1),
                                                _hoisted_38
                                            ])
                                        ]),
                                        _hoisted_39,
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_40, [
                                                _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(selectedEmployee)), 1),
                                                _hoisted_42
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                                (props.is_examable)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        onClick: _withModifiers(onClickMentor, ["prevent"]),
                                        style: { "cursor": "pointer" }
                                    }, "メンター申請", 8, _hoisted_44))
                                    : _createCommentVNode("", true),
                                _createVNode(_unref(Link), {
                                    href: _ctx.route('account.leave.show')
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("退会申請")
                                    ]),
                                    _: 1
                                }, 8, ["href"])
                            ])
                        ])
                    ]),
                    _createElementVNode("form", null, [
                        _createVNode(DisplayNameModal, {
                            value: form.name,
                            errors: errors.name,
                            onInput: onInputDisplayName,
                            onCancel: _cache[2] || (_cache[2] = ($event) => (setErrors(_unref(ProfileUpdateType).NAME, ''))),
                            ref_key: "displayNameModal",
                            ref: displayNameModal
                        }, null, 8, ["value", "errors"]),
                        _createVNode(IndustryModal, {
                            options: industryOptions.value,
                            id: (_a = form.industry_id) !== null && _a !== void 0 ? _a : undefined,
                            errors: errors.industry,
                            onSelected: onSelectedIndustry,
                            onCancel: _cache[3] || (_cache[3] = ($event) => (setErrors(_unref(ProfileUpdateType).INDUSTRY, ''))),
                            ref_key: "industryModal",
                            ref: industryModal
                        }, null, 8, ["options", "id", "errors"]),
                        _createVNode(JobModal, {
                            options: jobOptions.value,
                            form: form,
                            onSelected: onSelectedJob,
                            onCancel: _cache[4] || (_cache[4] = ($event) => (setErrors(_unref(ProfileUpdateType).JOB, ''))),
                            ref_key: "jobModal",
                            ref: jobModal
                        }, null, 8, ["options", "form"]),
                        _createVNode(CompanyProfileModal, {
                            value: form.company_profile,
                            onInput: onInputCompanyProfile,
                            onCancel: _cache[5] || (_cache[5] = ($event) => (setErrors(_unref(ProfileUpdateType).COMPANY_PROFILE, ''))),
                            ref_key: "companyProfileModal",
                            ref: companyProfileModal
                        }, null, 8, ["value"]),
                        _createVNode(AnnualSaleModal, {
                            options: annualSaleOptions.value,
                            id: (_b = form.annual_sale_id) !== null && _b !== void 0 ? _b : undefined,
                            onSelected: onSelectedAnnualSale,
                            onCancel: _cache[6] || (_cache[6] = ($event) => (setErrors(_unref(ProfileUpdateType).ANNUAL_SALE, ''))),
                            ref_key: "annualSaleModal",
                            ref: annualSaleModal
                        }, null, 8, ["options", "id"]),
                        _createVNode(EmployeeModal, {
                            options: employeeOptions.value,
                            id: (_c = form.employee_id) !== null && _c !== void 0 ? _c : undefined,
                            onSelected: onSelectedEmployee,
                            onCancel: _cache[7] || (_cache[7] = ($event) => (setErrors(_unref(ProfileUpdateType).EMPLOYEE, ''))),
                            ref_key: "employeeModal",
                            ref: employeeModal
                        }, null, 8, ["options", "id"])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
